import React, { useState, useEffect } from "react"
import { computeProgramAssessmentPerformance } from "../../../utils/programDetailHelpers"

const StatCard = ({ label, value }) => (
  <div className="bg-background border border-border rounded-lg p-4">
    <p className="text-xs text-muted-foreground mb-1">{label}</p>
    <p className="text-2xl font-bold text-foreground">{value}</p>
  </div>
)

const ProgramAssessmentsTab = ({ orgId, courseIds }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeProgramAssessmentPerformance(orgId, courseIds || []).then((result) => {
      setData(result)
      setLoading(false)
    })
  }, [orgId, courseIds])

  if (loading || !data) return <div className="p-8 text-center text-sm text-muted-foreground">Loading assessment data...</div>

  if (data?.totalCompleted === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-6">
        <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide mb-1">Assessments</h3>
        <p className="text-sm text-muted-foreground">No quiz or capstone attempts yet across this program's courses.</p>
      </div>
    )
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide mb-5">Assessments</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard label="Assessments Completed" value={data?.totalCompleted?.toLocaleString()} />
        <StatCard label="Average Score" value={`${data?.avgScore}%`} />
        <StatCard label="Pass Rate" value={`${data?.passRate}%`} />
      </div>
    </div>
  )
}

export default ProgramAssessmentsTab